// extracted by css-extract-rspack-plugin
export default {"measureAvailable":"_2hfbG","measureRequired":"KiAewh"};